<template>
  <div class="app-header" >
    <div class="main">
        <div class="float">
          <div class="headlerlogotitle" @click="imgClick()" @mouseenter="zoneType = false">
          <el-image  style="width:361px;height:60px" :src="require('@@/assets/images/header/title.png')"></el-image>
          </div>
          <div class="header-elMenu">
              <el-menu mode="horizontal" :default-active="current" class="headmenu" active-text-color="#2461B1" text-color="#3D464E" @select="handleSelect">
                <template v-for="item in menuItems">
                  <el-menu-item v-if="!item.children || !item.children.length" :key="item.location" :index="item.location" style="height: 30px">
                    <a v-if="item.location === '/zone'"  @mouseenter="handleMouseEnter"  >{{ item.label }}</a>
                    <a v-else :href="item.location" @mouseenter="zoneType = false" @click.prevent >{{ item.label }}</a>
                    <div v-if="current === item.location" style="margin: 4px 15px 0 15px ;height: 4px;background: #2461B1;"></div>
                  </el-menu-item>
                  <el-submenu v-else :key="item.location" :index="item.location">
                    <template slot="title"><span >{{ item.label }}</span></template>
                    <el-menu-item v-for="child in item.children" :key="child.location" style="height: 30px">
                      <a :href="child.location" @click.prevent>{{ child.label }}</a>
                    </el-menu-item>
                  </el-submenu>
                </template>
              </el-menu>
          </div>
        </div>

    </div>

  </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
      showbox: true,
      usertype: "0",
      topath: "",
      current: "/home",
      islogin: false,//是否已登陆
      menuItems: [
        {label: "网站首页", location: "/home",},
        {label: "交易信息", location: "/about",},
        {label: "下载中心", location: "/download",},
        {label: "电子保函", location: "/guarantee",},
        {label: "关于我们", location: "/ourself",},
      ],

      ggName:'',
    };
  },
  created() {
    let menu = sessionStorage.getItem("menu");
    this.current = menu ? (menu == "/" ? "/home" : menu) : "/home";
  },
  mounted() {

  },
  methods: {
    // 顶部导航跳转
    handleSelect(path) {
      this.toPage(path,'');
    },
    // 页面跳转
    toPage(path, val) {
      if(path === '/zone') return
      if (path === '/guarantee')return   window.open('https://www.gzzczb.com/guarantee')
      if (path === '/bidEvaluationOffice') window.open('https://www.gzzczb.com/bidEvaluationOffice/')
      this.$router.push({path: path, query: val});
    },
    imgClick(){
      this.$router.push({path: "/home",});
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler(n) {
        this.$nextTick(() => this.current = n.path)
      }
    }
  }
};
</script>
<style scoped lang="less">
.app-header{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 80px;
}
.main{
  height: 100%;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;

}

.float{
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headlerlogotitle {
  width: 361px;
  height: 60px;
}
.header-elMenu{
  width: calc(100% - 361px - 269px);
  display: flex;
  justify-content: right;
  align-items: flex-end;
  height: 100%;
}
::v-deep .el-menu{
  width: 100% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent !important;
  height: 60px;
}
::v-deep .el-menu-item {
  width: calc(100% / 5);
  height: 30px;
  font-size: 20px;
  text-align: center;
}
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}
& > div {
  height: inherit;
  align-items: center;
}

::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  border: none;
}
::v-deep .el-menu--horizontal > .el-menu-item:hover{
  border: none;
}
::v-deep .el-menu--horizontal>.el-menu-item{
  line-height: 30px;
}
.zone{
  width: 1000px;
  height: 272px;
  background: #FFFFFF;
  padding: 20px 32px;
  position: absolute;
  right: 0;
  top: 48px;
  z-index: 999;
}
.zoneId{
  border: 1px solid #DCDCDC;
  &:hover{
    border-radius: 2px 2px 2px 2px;
    border: 2px solid #0763CE;
  }
}
</style>
